export default "__VITE_ASSET__eG0ZUDFf__"